module.exports = __webpack_public_path__ + "static/Q7Answer1_Forest_SebastianUnrau-82051e5b3d31abbd79a8556c8bcde9ec.jpg";